import { useBrowserSupport } from '@/shared/composables/browser-api'
import { useLocalization } from '@/shared/composables/localization'
import { tauriMode } from '@/shared/utils/import-meta'

interface HTMLAudioElementOverrideSetSinkID {
  setSinkId?: (deviceId: string) => Promise<MediaStream>
}
export type HTMLAudioElementWithSetSinkId = Modify<HTMLAudioElement, HTMLAudioElementOverrideSetSinkID>
let outputSource: MediaElementAudioSourceNode

export function useSetAudioOutput (mediaElement: HTMLAudioElementWithSetSinkId | HTMLAudioElement, deviceId: string): Promise<boolean> {
  return new Promise(async (resolve, reject) => {
    if (tauriMode()) {
      try {
        if (!outputSource) {
          const context = new AudioContext()
          outputSource = context.createMediaElementSource(mediaElement as HTMLAudioElement)
          outputSource.connect(context.destination)
        }
        resolve(true)
      } catch (error) {
        reject(error)
      }
    } else {
      const { canUseSetAudioOutput } = useBrowserSupport()
      const { t } = useLocalization()
      const isBrowserSupport = await canUseSetAudioOutput(mediaElement as HTMLAudioElementWithSetSinkId)

      if (!isBrowserSupport) { reject(new Error(t('common.browserNotSupportSetSinkId'))) }

      (mediaElement as HTMLAudioElementWithSetSinkId).setSinkId?.(deviceId).then(() => {
        resolve(true)
      }).catch((error) => reject(error))
    }
  })
}


type Modify<T, R> = Pick<T, Exclude<keyof T, keyof R>> & R
